module.exports = __webpack_public_path__ + "img/weather44.990cea6f.png";